export default __webpack_public_path__ + "fcb187270fac51a4af20d01ff166776b.obj";